/**
 *
 * NotesLanding
 *
 */

import { mapGetters } from 'vuex';
import _ from 'lodash';

import { NotesDownloadMixin } from '@/scripts/Notes/mixins/NotesDownload';
import { DownloadModalMixin } from '@/scripts/Notes/NotesLanding/mixins/DownloadModal';

export default {
  name: 'DownloadNoteModal',

  mixins: [NotesDownloadMixin, DownloadModalMixin],

  data: () => {
    return {
      selectedBookIdsForDownload: [],
    };
  },

  computed: {
    ...mapGetters('Notes/NotesLanding', {
      mg_currentCourse: 'currentCourse',
      mg_currentCourseAllBooks: 'currentCourseAllBooks',
    }),

    c_isSelectedAllBooksForDownload() {
      return this.mg_currentCourseAllBooks.length === this.selectedBookIdsForDownload.length;
    },

    c_isSelectedNoneBooksForDownload() {
      return 0 === this.selectedBookIdsForDownload.length;
    },

    ///
    c_selectedCourseForDownload() {
      return {
        courseId: this.mg_currentCourse.course_id,
        courseName: this.mg_currentCourse.course_name,
      };
    },

    ///
    c_strSelectedBookIdsForDownload() {
      return _.join(this.selectedBookIdsForDownload, ',');
    },
  },

  methods: {
    toggleAllBooksForDownload() {
      this.selectedBookIdsForDownload = !this.c_isSelectedAllBooksForDownload
        ? [...this.mg_currentCourseAllBooks]
        : [];
    },

    ///
    async callbackOnModalShow() {
      await this.$nextTick();
      this.toggleAllBooksForDownload();
    },

    ///
    callbackOnModalHidden() {
      this.selectedBookIdsForDownload = [];
    },
  },
};
